import { parseJwt } from "@/utils/auth"
import Bounties from "./bounties/bounties.module"
import { SCOPES } from "./aimlabs-marketplace.constants"

const state = {}

const mutations = {}

const actions = {
  initAimlabsAccountLink: async ({ dispatch }) => {
    await dispatch("Auth/bindAimlabsAuthListener", null, { root: true })
    dispatch("Auth/beginAimLabSSO", null, { root: true })
  },
  unlinkAimlabsAccount: ({ getters, dispatch }) => {
    const providerId = getters.aimlabsIdentity?.id
    if (!providerId) {
      return
    }

    dispatch("Auth/disconnectOauth", {
      provider_id: providerId,
    }, { root: true })
  },
  refreshAccessToken: async ({ dispatch }) => {
    await dispatch("Auth/refreshAimlabsToken", null, { root: true })
  },
}

const getters = {
  accountLinkError: (state, getters, rootState, rootGetters) => {
    return rootGetters["Auth/SSOLinkError"] ?? null
  },
  aimlabsIdentity: (state, getters, rootState, rootGetters) => {
    const linkedIdentities = rootGetters["Auth/oauthProviders"] ?? []
    return linkedIdentities.find((oauthProvider) => {
      return oauthProvider.provider === "aim-lab"
    })
  },
  aimlabsAccountConnected: (state, getters) => {
    return !!getters.aimlabsIdentity
  },
  isAcceptingBounties: (state, getters) => {
    const jwtPayload = parseJwt(getters.aimlabsIdentity?.access_token)
    const accessTokenScopes = (jwtPayload?.scope ?? "").split(" ")
    return accessTokenScopes.includes(SCOPES.CREATOR)
  },
  accessToken: (state, getters) => {
    return getters.aimlabsIdentity?.access_token ?? ""
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
  modules: {
    Bounties,
  },
}



// WEBPACK FOOTER //
// ./src/store/coach/dashboard/aimlabs-marketplace/aimlabs-marketplace.module.js